/*
|--------------------------------------------------------------------------
| Utilities: 3rd Party iframes
|--------------------------------------------------------------------------
*/
/**
 * Lazy Ads
 * @namespace
 */
__gh__webApp.utilities["3rdPartyIframes"] = {
	"init": function(){
		this.bindEvents();
	},

	"loadIframe": function(){
		var $3rdPartyIframe = $("[data-3rd-party-iframe-src]").first();

		//Check to see if iframe is within 300px
		if ($3rdPartyIframe.length && $3rdPartyIframe.isOnScreen(500)){

	    	var src = $3rdPartyIframe.data("3rd-party-iframe-src");
	    		$3rdPartyIframe.attr("src",src);
				$3rdPartyIframe.removeAttr("data-3rd-party-iframe-src");
	    }
	},

	"bindEvents": function(){
		$(document).on("scroll.3rd-party-iframes",this.loadIframe);
	}
};